import EpButton from './button';
import EpBanner from './banner';
import EpSpinner from './spinner';
import EpBottomPopup from './bottom_popup';

const globalComponents = (app) => {
    app.component('ep-button', EpButton);
    app.component('ep-banner', EpBanner);
    app.component('ep-spinner', EpSpinner);
    app.component('ep-bottom-popup', EpBottomPopup);
}

export default globalComponents;
